export default __webpack_public_path__ + "static/media/doodle.64821a3c.svg";